import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '@/api/common';

import type { CustomerDocuments } from './types';

type Variables = {
  customerId: number;
};
type Response = CustomerDocuments;

export const useCustomerDocuments = createQuery<
  Response,
  Variables,
  AxiosError
>({
  queryKey: ['internal/partners/organizations/customers/documents'],
  fetcher: ({ customerId }) =>
    client
      .get(
        `v2/internal/partners/organizations/customers/${customerId}/documents`
      )
      .then((response) => response.data.data),
});
